<template>
  <div class="tab-content-box clearfix">
    <div class="left-content custom-left-content">
      <div
        ref="leftCode"
        class="code-html-box chrome_scrollbar"
      >
        <h2 class="code-html-tit">
          {{ $t('message["1529"]') }}
        </h2>
        <div class="code-html chrome_scrollbar">
          <pre>{{ codeHtml }}</pre>
        </div>
      </div>
    </div>
    <div class="right-content">
      <div
        ref="rightContent"
        class="right-c-c"
      >
        <div class="custom-right-tit">
          <h2>{{ $t('message["1435"]') }}</h2>
          <div class="custom-op-box">
            <a-button @click="cancleCustom">
              {{ $t('message["896"]') }}
            </a-button>
            <a-button
              type="primary"
              @click="setCustomCss"
            >
              {{ $t('message["1493"]') }}
            </a-button>
          </div>
        </div>
        <div class="code-mirror">
          <codemirror
            v-model="styleDatas.custom_css"
            :options="options"
            style="height: 600px;"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { codemirror } from 'vue-codemirror'
import { cloneDeep } from 'lodash'
import { appendStyle, getH } from '@/store/universalForm/convert'
import 'codemirror/lib/codemirror.css'
require('codemirror/mode/css/css')
require('codemirror/theme/blackboard.css')
require('codemirror/addon/hint/show-hint.js')
require('codemirror/addon/hint/show-hint.css')
require('codemirror/addon/hint/css-hint.js')
export default {
  components: {
    codemirror
  },
  data () {
    return {
      mode: 'text/css',
      cloneCss: ''
    }
  },
  computed: {
    ...mapState('universalForm/form', ['styleDatas', 'datasReady', 'codeHtml']),
    options: function () {
      return {
        mode: this.mode,
        tabSize: 2,
        lineNumbers: true,
        lineWrapping: true,
        // viewportMargin: Infinity,
        extraKeys: { 'Ctrl-Space': 'autocomplete' }
      }
    }
  },
  created () {
    this.cloneCss = cloneDeep(this.styleDatas.custom_css)
  },
  mounted () {
    this.$nextTick(() => {
      let $main = this.$refs.rightContent
      getH($main, 212)
      let leftele = this.$refs.leftCode
      getH(leftele, 212)
    })
  },
  methods: {
    setCustomCss (b) {
      appendStyle(this.styleDatas.custom_css, 'custom-css')
      this.styleDatas.custom_css = this.styleDatas.custom_css
      this.$emit('applyCustom')
    },
    cancleCustom () {
      appendStyle(this.cloneCss, 'custom-css')
      this.styleDatas.custom_css = this.cloneCss
      this.$emit('cancelCustom')
    }
  }
}
</script>
<style lang="scss" scoped>
.right-c-c {
  width: 570px;
  padding-right: 24px;
}
.tab-content-box {
  .custom-left-content {
    background: #f5f5f5;
    // padding: 16px 24px 0 16px !important;
    .code-html-box {
      overflow-y: auto;
      .code-html-tit {
        border-bottom: 1px solid #ebebeb;
        height: 48px;
        line-height: 48px;
        font-weight: 600;
      }
      .code-html {
        padding: 16px 0;
        color: #666;
        pre {
          overflow: initial;
        }
      }
    }
  }
  .custom-right-tit {
    position: relative;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #ebebeb;
    h2 {
      font-weight: 600;
    }
    .custom-op-box {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
